const environment = {
  development: {
    API_URL: 'http://localhost:8080/api/v1.0.0',
  },
  staging: {
    API_URL: 'https://server.dev.multitaxx.com/api/v1.0.0',
  },
  production: {
    API_URL: 'https://server.multitaxx.com/api/v1.0.0',
  },
};

const config = environment[process.env.NODE_ENV] || environment.development;

export default config;
